import { type YupAnyObjectSchema } from '@framework/validation/YupObjectSchema.ts';
import { Flex } from 'antd';
import { type SearchableField } from '../../ISearchableField.tsx';
import { FilterBarAddPopover } from '../popover/FilterBarAddPopover.tsx';
import { FilterBarChip } from './FilterBarChip.tsx';

export interface IFilterBarChipRowProps {
  fields: SearchableField[];
  /** Query corrente (parsata): sorgente di verità per inizializzare il form
   * annidato del popover edit. */
  query: Record<string, any>;
  /** Schema dei filtri, propagato al `FormHandler` annidato del popover. */
  schema: YupAnyObjectSchema;
  /** Nomi dei campi mostrati come chip (gestiti da `useShownFilterNames`). */
  shownFieldNames: string[];
  /** Chiamata quando l'utente aggiunge un nuovo filtro via popover inline. */
  onAdded: (name: string) => void;
  /** Chiamata quando l'utente rimuove un chip via "×". */
  onRemoved: (name: string) => void;
}

/** Riga dei chip attivi + chip dashed "+ Filtro" per aggiungerne uno nuovo. */
export function FilterBarChipRow({
  fields,
  query,
  schema,
  shownFieldNames,
  onAdded,
  onRemoved,
}: Readonly<IFilterBarChipRowProps>) {
  return (
    <Flex wrap gap={4} align="center">
      {shownFieldNames.map(name => {
        const field = fields.find(f => f.name === name);
        if (!field) return null;
        return (
          <FilterBarChip
            key={name}
            field={field}
            fields={fields}
            query={query}
            schema={schema}
            onRemove={() => onRemoved(name)}
          />
        );
      })}
      <FilterBarAddPopover
        variant="inline"
        fields={fields}
        query={query}
        schema={schema}
        excludeNames={shownFieldNames}
        onAdded={onAdded}
      />
    </Flex>
  );
}
